import { FocusEvent } from "react"
import { getNames, registerLocale } from "i18n-iso-countries"
import norwegianCountryNames from "i18n-iso-countries/langs/nb.json"
import { SearchableSelectField } from "components/common/formFields/SearchableSelectField/SearchableSelectField"

registerLocale(norwegianCountryNames)

export const defaultCountryName = "Norge"

// The full Norwegian name is both shown and stored, e.g. "Norge"
const countryOptions = Object.values(getNames("nb", { select: "official" }))
  .sort((a, b) => a.localeCompare(b, "nb"))
  .map(name => ({ label: name, value: name }))

export interface CountrySelectFieldProps {
  value: string
  onChange: (countryName: string) => void
  onBlur?: (event: FocusEvent) => void
}

export const CountrySelectField = (props: CountrySelectFieldProps) => {
  return (
    <SearchableSelectField
      options={countryOptions}
      value={countryOptions.find(option => option.value === props.value)}
      onChange={value => props.onChange(String(value ?? ""))}
      onBlur={props.onBlur}
    />
  )
}
